// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-cart-signup[data-v-bd7af45c] .row{margin-right:0;margin-left:0;width:auto}", ""]);
// Exports
module.exports = exports;
